import { MB_CONFIG } from '../config'

export default {

    PHOTOS: (examinationID) => axios.get(MB_CONFIG.API_URL + '/photos/examination/' + examinationID),

    destroy: (data) => axios.delete(MB_CONFIG.API_URL + '/photos/bulk_delete', { data: data }),

    url: (photoID) => MB_CONFIG.API_URL + '/photos/' + photoID,

    uploadURL: (examinationID) => MB_CONFIG.API_URL + '/photos/examination/' + examinationID + '/upload',

    THUMB: (photoID) => axios.get(MB_CONFIG.API_URL + '/photos/' + photoID + '/thumb', { responseType: 'blob' }),

    PHOTO: (photoID) => axios.get(MB_CONFIG.API_URL + '/photos/' + photoID, { responseType: 'blob' }),

}
